module.exports = __webpack_public_path__ + "static/media/twittericon.96646125.svg";